import { render, staticRenderFns } from "./lk.vue?vue&type=template&id=fc8ba880&"
import script from "./lk.vue?vue&type=script&lang=js&"
export * from "./lk.vue?vue&type=script&lang=js&"
import style0 from "./lk.vue?vue&type=style&index=0&id=fc8ba880&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports